module.exports = __webpack_public_path__ + "img/re_IMG_1221.679a228c.jpeg";